import { Route } from '@angular/router'

export const SOFTWARES: Route[] = [
    {
        path: '',
        loadComponent: () =>
            import('../features/softwares/softwares.page').then((c) => c.SoftwaresPage),
    },
    {
        path: 'old',
        loadComponent: () =>
            import('../software/software-list/software-list.component').then(
                (c) => c.SoftwareListComponent
            ),
    },
    {
        path: 'details',
        loadComponent: () =>
            import('../software/software-details/software-details.component').then(
                (c) => c.SoftwareDetailsComponent
            ),
    },
    {
        path: 'map-assets',
        loadComponent: () =>
            import('../helpers/components/map-assets/map-assets.component').then(
                (c) => c.MapAssetsComponent
            ),
    },
]
